import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import { leadAssignedTable } from "assets/properties/properties";
import brandTheme from "brandTheme/Theme";
import AdminTable from "components/UpdateUi/Table/AdminTable";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import { applicationStatusList } from "assets/properties/properties";
import { parseTimeDate } from "utils/Utils";
import { useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { parseDate } from "utils/Utils";
import ToastModal from "views/components/ToastModal";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";

const useStyles = makeStyles((theme) => ({
  page: {
    padding: "20px",
  },

  title: {
    fontSize: "28px",
    fontWeight: 700,
    color: brandTheme.mainColor,
    marginBottom: "4px",
  },

  subtitle: {
    color: "#666",
    marginBottom: "20px",
  },

  filterContainer: {
    backgroundColor: "#fff",
    border: "1px solid #e1e1e1",
    borderRadius: "8px",
    padding: "18px",
    marginBottom: "15px",
  },

  filterButton: {
    height: "40px",
    backgroundColor: brandTheme.mainColor,
    color: "#fff",

    "&:hover": {
      backgroundColor: brandTheme.mainColor,
    },
  },

  resetButton: {
    height: "40px",
    border: "1px solid #ccc",
  },

  bulkContainer: {
    backgroundColor: "#fff",
    border: "1px solid #e1e1e1",
    borderRadius: "8px",
    padding: "18px",
    marginBottom: "10px",
  },

  bulkTitle: {
    fontSize: "16px",
    fontWeight: 700,
    color: brandTheme.mainColor,
    marginBottom: "10px",
  },

  bulkRow: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },

  rangeContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },

  selectedBar: {
    backgroundColor: "#f4f8ff",
    border: "1px solid #dce8ff",
    borderRadius: "6px",
    padding: "12px 15px",
    marginBottom: "10px",

    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "15px",
  },

  selectedText: {
    color: "#16833a",
    fontWeight: 600,
  },

  selectedIds: {
    color: brandTheme.mainColor,
    fontWeight: 500,
    marginLeft: "10px",
  },

  assignButton: {
    backgroundColor: "#12a65a",
    color: "#fff",
    fontWeight: 600,

    "&:hover": {
      backgroundColor: "#0d914d",
    },
  },

  unassignButton: {
    backgroundColor: "#f44336",
    color: "#fff",
    fontWeight: 600,

    "&:hover": {
      backgroundColor: "#d32f2f",
    },
  },

  clearButton: {
    color: "#1457d9",
  },

  status: {
    padding: "5px 10px",
    borderRadius: "5px",
    fontSize: "12px",
    fontWeight: 600,
  },

  inProcess: {
    backgroundColor: "#e7f0ff",
    color: "#1769d1",
  },

  approved: {
    backgroundColor: "#e7f8ed",
    color: "#16833a",
  },

  submitted: {
    backgroundColor: "#f1e7ff",
    color: "#8134c9",
  },
}));

const LeadAssignmentTable = () => {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [users, setUsers] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedUserFilter, setSelectedUserFilter] = useState("");
  const [leadStatus, setLeadStatus] = useState("INPROCESS");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);
  const [selectionType, setSelectionType] = useState("leadIds");
  const [leadIdsInput, setLeadIdsInput] = useState("");
  const [fromLeadId, setFromLeadId] = useState("");
  const [toLeadId, setToLeadId] = useState("");
  const [assignTo, setAssignTo] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [usersFetched, setUsersFetched] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const getDefaultDateRange = () => {
    const today = new Date();

    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    return {
      startDate: parseDate(sevenDaysAgo),
      endDate: parseDate(today),
    };
  };
  useEffect(() => {
    const { startDate, endDate } = getDefaultDateRange();
    setToDate(endDate);
    setFromDate(startDate);
    getUserLoanDetails("INPROCESS", startDate, endDate);
    getAllUserDetails();
  }, []);

  const applyLeadIds = () => {
    const ids = leadIdsInput
      .split(",")
      .map((id) => Number(id.trim()))
      .filter((id) => !isNaN(id) && id > 0);

    if (!ids.length) {
      return;
    }

    setSelectedLeadIds([...new Set(ids)]);
  };

  const getUserLoanDetails = async (
    status = "INPROCESS",
    filterStartDate = fromDate,
    filterEndDate = toDate,
    filterSearch
  ) => {
    setCallInProgress(true);
    const applicationStatus =
      status === "APPROVED"
        ? "INPROCESS&decision=APPROVED"
        : status || "INPROCESS";
    const result = await apiHandler({
      url:
        endpoint.LEAD_SEARCH_API +
        applicationStatus +
        `&startDate=${filterStartDate}&endDate=${filterEndDate}`,
      method: "GET",
      authToken: authToken,
    });

    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      // setRawData(result?.data);

      parseIndicatorData(result?.data);
    }
  };

  const onHandleLeadStatusChange = (value) => {
    getUserLoanDetails(value);
    setLeadStatus(value);
  };

  const parseIndicatorData = (data, userDetails, searchText = "") => {
    let reportData = [];

    data = data?.sort((a, b) => (a?.id < b?.id ? 1 : -1));

    data &&
      data.forEach((leadDetails, index) => {
        let row = {
          id: index + 1,
          leadId: leadDetails?.id,
          loanAccountNumber: leadDetails?.loanAccountNumber,
          customerId: leadDetails?.customerId,
          customerName: leadDetails?.name,
          mobileNumber: leadDetails?.mobileNumber,
          leadStatus: leadDetails?.status,
          assignedTo: leadDetails?.assignedTo || "Unassigned",
        };

        reportData.push(row);
      });

    // Keep complete data separately
    setAllRows(reportData);

    // Initially show complete data
    setRows(reportData);
  };

  const clearSelection = () => {
    setSelectedLeadIds([]);
    setLeadIdsInput("");
    setFromLeadId("");
    setToLeadId("");
  };

  const handleAssign = async () => {
    if (!selectedLeadIds.length) {
      alert("Please select Lead IDs.");
      return;
    }

    if (!assignTo) {
      alert("Please select a user.");
      return;
    }

    const result = await apiHandler({
      url: endpoint.ASSIGN_LEAD_TO_USER,
      method: "POST",
      authToken: authToken,
      data: {
        leadIds: selectedLeadIds,
        assignTo: assignTo,
      },
    });
    if (result?.data?.error_code) {
      console.log("asdkjjaksdh");
    } else {
      getUserLoanDetails();
    }
  };

  const handleUnassign = async () => {
    if (!selectedLeadIds.length) {
      alert("Please select Lead IDs.");
      return;
    }

    const result = await apiHandler({
      url: endpoint.UNASSIGNED_LEAD_TO_USER,
      method: "POST",
      authToken: authToken,
      data: {
        leadIds: selectedLeadIds,
      },
    });
    if (result?.data?.error_code) {
      console.log("asdkjjaksdh");
    } else {
      console.log("asdkjjaksdh1111");
      getUserLoanDetails();
    }
  };

  const getAllUserDetails = async () => {
    const result = await apiHandler({
      url: endpoint.GET_ALL_USER_DETAILS,
      method: "GET",
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      console.log("asdkjjaksdh");
    } else {
      console.log("asdkjjaksdh1111");
      const filterUsers  = result?.data?.filter((user) => user?.designation === "TELECALLER" && user?.active === true);
      setUsers(filterUsers);
    }
  };

  const handleSearchApplications = () => {
    getUserLoanDetails(leadStatus, fromDate, toDate, searchValue);
  };
  const handleSearchChange = (value) => {
    setSearchValue(value);
    const searchText = String(value || "")
      .toLowerCase()
      .trim();
    if (!searchText) {
      setRows(allRows);
      return;
    }
    const filteredData = allRows.filter(
      (row) =>
        String(row?.leadId || "")
          .toLowerCase()
          .includes(searchText) ||
        String(row?.loanAccountNumber || "")
          .toLowerCase()
          .includes(searchText) ||
        String(row?.customerId || "")
          .toLowerCase()
          .includes(searchText) ||
        String(row?.customerName || "")
          .toLowerCase()
          .includes(searchText) ||
        String(row?.mobileNumber || "")
          .toLowerCase()
          .includes(searchText)
    );
    setRows(filteredData);
  };
  return (
    <div className={classes.page}>
      <SubHeader
        label="Lead Assignment"
        dateFilter
        searchLabel="Search"
        searchValue={searchValue}
        onSearchChange={handleSearchChange}
        fromDate={fromDate}
        toDate={toDate}
        onFromDateChange={setFromDate}
        onToDateChange={setToDate}
        onDateSearch={handleSearchApplications}
        searchButtonLabel="Search"
        noButton
      />
      <div className={classes.bulkContainer}>
        <Typography className={classes.bulkTitle}>
          Bulk Assign / Unassign
        </Typography>
        <RadioGroup
          row
          value={selectionType}
          onChange={(event) => setSelectionType(event.target.value)}
        >
          <FormControlLabel
            value="leadIds"
            control={<Radio color="primary" />}
            label="Enter Lead IDs"
          />
        </RadioGroup>
        {selectionType === "leadIds" && (
          <div className={classes.bulkRow}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Lead IDs (comma separated)"
              placeholder="Example: 1, 5, 7, 12"
              value={leadIdsInput}
              onChange={(event) => setLeadIdsInput(event.target.value)}
            />

            <Button
              variant="contained"
              className={classes.filterButton}
              onClick={applyLeadIds}
            >
              Apply
            </Button>
          </div>
        )}
      </div>

      {selectedLeadIds.length > 0 && (
        <div className={classes.selectedBar}>
          <div>
            <span className={classes.selectedText}>
              ✓ {selectedLeadIds.length} Leads Selected
            </span>

            <span className={classes.selectedIds}>
              IDs: {selectedLeadIds.join(", ")}
            </span>

            <Button
              size="small"
              className={classes.clearButton}
              onClick={clearSelection}
            >
              Clear Selection
            </Button>
          </div>

          <div className={classes.bulkRow}>
            <FormControl
              variant="outlined"
              size="small"
              style={{
                minWidth: 200,
              }}
            >
              <InputLabel>Assign To</InputLabel>

              <Select
                value={assignTo}
                onChange={(event) => setAssignTo(event.target.value)}
                label="Assign To"
              >
                <MenuItem value="">Select User</MenuItem>

                {users.map((user) => (
                  <MenuItem key={user.username} value={user.username}>
                    {user.username}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              className={classes.assignButton}
              onClick={handleAssign}
            >
              Assign Lead IDs ({selectedLeadIds.length})
            </Button>
            <Button
              variant="contained"
              className={classes.unassignButton}
              onClick={handleUnassign}
            >
              Unassign Lead IDs ({selectedLeadIds.length})
            </Button>
          </div>
        </div>
      )}

      <Grid
        container
        spacing={2}
        alignItems="center"
        style={{ justifyContent: "flex-end", paddingRight: "3%" }}
      >
        <Grid item xs={12} sm={6} md={4}>
          <CustomSelect
            label="Lead Type"
            value={leadStatus}
            onChange={(e) => onHandleLeadStatusChange(e.target.value)}
            options={applicationStatusList}
          />
        </Grid>
      </Grid>

      <AdminTable
        columns={leadAssignedTable}
        rows={rows}
        searchValue={searchValue}
        selectable={true}
        selectedRows={selectedLeadIds}
        onSelectionChange={setSelectedLeadIds}
      />
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

export default LeadAssignmentTable;
